"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const genStyle_1 = require("../genStyle");
const constants_1 = require("../../../elements/course/CoursePreloader/constants");
const theme_1 = require("../../theme");
const font_1 = require("../../font");
const styleSchema = {
    page: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryBackgroundColor }),
    },
    description: {
        show: (0, genStyle_1.genStyle)({ value: true }),
    },
    loader: {
        show: (0, genStyle_1.genStyle)({ value: true }),
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.neutralColor }),
        color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryColor }),
    },
    size: {
        width: (0, genStyle_1.genStyle)({ value: 200 }),
        height: (0, genStyle_1.genStyle)({ value: 80 }),
    },
    logo: {
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
    },
};
const fontSchema = {
    base: Object.assign({}, font_1.FONT_SCHEMA_EMPTY.base),
};
exports.default = { [constants_1.TYPE]: { style: styleSchema, font: fontSchema, feedback: {} } };
